import $ from 'jquery';

export default class InstagramFeed {
  constructor({ el }) {
    this.$el = $(el);
    this.initializedClass = 'instagram-initialized';
    this._validate();
  }

  _validate() {
    this.$photoContainer = $('[data-instagram-photos]', this.$el);
    this.accessTokenError = this.$el.find('[data-instagram-error]').attr('data-instagram-error');
    const accessToken = $('[data-instagram-token]', this.$el).attr('data-instagram-token');
    const photoCount = $('[data-instagram-photo-count]', this.$el).attr('data-instagram-photo-count');
    const isInitialized = this.$el.hasClass(this.initializedClass);

    this._getPhotos(accessToken, photoCount, isInitialized);
  }

  _getPhotos(accessToken, photoCount, isInitialized) {
    if (!accessToken.length) {
      this._hasError(false);
      return;
    }
    if (isInitialized) { return; }

    const url = `https://api.instagram.com/v1/users/self/media/recent?access_token=${accessToken}&count=${photoCount}&callback=`;

    $.ajax({
      type: 'GET',
      dataType: 'jsonp',
      url,

      success: (response) => {
        if (response.meta.code === 200) {
          this.$photoContainer.empty();
          response.data.forEach((photo) => {
            if (photo && photo.images
              && photo.images.standard_resolution
              && photo.images.standard_resolution.url
            ) {
              this.$photoContainer.append(
                `
                  <a
                    class="instagram-photo"
                    href="${photo.link}"
                    target="_blank"
                    style="background-image: url('${photo.images.standard_resolution.url}')"
                  >
                  </a>
                `,
              );
            } else {
              this._hasError(response);
            }
          });
        }
      },
      error: response => this._hasError(response),
    });
  }

  _hasError(response) {
    this.$el.removeClass(this.initializedClass);
    this.$photoContainer.append(`<div class="instagram-error" data-instagram-error>${this.accessTokenError}</div>`);
    this.$errorContainer = this.$photoContainer.find('[data-instagram-errror]');
    if (response) { console.log(`Instagram error: ${response.meta.error_message}`); }
  }

  update() {
    this._validate();
  }
}
